/**
 * Created by JackCui on 2022/11/23
 */

import _ from 'lodash-es'
import moment from 'moment'
import processRelate from 'fe-coms-share/paas/business/process-relate'
import {FIELD_TYPE, FIELD_VALUE_TYPE, HEADER_PARAMS_KEYS} from 'fe-coms-share/paas/constants'
import {interfacesHandle} from 'fe-coms-share/paas'
import {getOrganization, getUserInfo} from '../store/local-catch/user'
import cachedRequest from '../../../../utils/cached-request'
import projectInfo from './project-info'

// 不同字段类型的赋值处理
const beforeAssignmentHandle = {
  [FIELD_TYPE.PERSONNEL]: ({node, value}) => {
    // 人员字段赋值的时候需要考虑数据源
    const {purDataOrigin, surDataOrigin} = node.field
    const project = projectInfo.query()
    const dataOrigin = {
      'pur': purDataOrigin && !surDataOrigin,
      'sur': !purDataOrigin && surDataOrigin,
      'mall': purDataOrigin && !surDataOrigin
    }
    return dataOrigin[project]
      ? value
      : ''
  },
  [FIELD_TYPE.NUMBER]: ({value}) => {
    return value
  },
  [FIELD_TYPE.LOOKUP_RELATION]:  ({value}) => {
    return _.cloneDeep(value) || {}
  },
  [FIELD_TYPE.FILE]:  ({value}) => {
    return value || []
  },
  [FIELD_TYPE.DATE]:  ({value}) => {
    return value || ''
  },
  default ({value, parentNode}) {
    let _value = value
    // 处理常量
    if (parentNode?.fieldApiName.includes('global__')) {
      try {
        _value = eval(_value)
      } catch (e) {
        _value = value
      }
    }
    return _value
  }
}
// 缓存查询值
let catchRows = {}

export default {
  methods: {
    // 如果新建的节点 父节点有value则 单独触发一下节点的更新 回显值
    _triggerRelate (node) {
      this.$nextTick(() => {
        const parentNode = processRelate.getNode(node)
        // 判断父节点是否有值 有值则在首次初始化完执行一下
        if (parentNode.hasOwnProperty('value')) {
          processRelate.triggerNodes(node)
        }
      })
    },
    // 根据配置创建关联关系
    createRelate (formula, node) {
      processRelate.creatRelate(
        {
          ...formula,
          value: _.get(this.formData, this.getPath(formula)),
          rowId: formula.objectApiName === node.objectApiName ? node.rowId : ''
        },
        {
          handler: this._handlerTrigger.bind(this),
          ...node
        }
      )
      this._triggerRelate(formula)
    },
    // 根据布局初始化关联关系
    initRelatePages (fieldMap, subObjectParamName = '', row) {
      for (let o in fieldMap) {
        const field = fieldMap[o]
        const formulaFieldList = field?.defaultValue?.formulaFieldList
        if (!formulaFieldList) {
          continue
        }
        for (let i = 0; i < formulaFieldList.length; i++) {
          const v = formulaFieldList[i]
          const {apiName, objectApiName} = field
          const {relationFieldType, relationFieldApiName, relationFieldObjectApiName, ...reset} = v
          this.createRelate({
            ...reset,
            field: this.getField(v)
          }, {
            objectApiName,
            fieldApiName: apiName,
            rowId: row?.['aPaaS_SequenceId'] || '',
            subObjectParamName,
            relationFieldType,
            relationFieldApiName,
            relationFieldObjectApiName,
            field: this.getField({
              objectApiName,
              fieldApiName: apiName,
            })
          })
        }
      }
      catchRows = {}
      console.log(processRelate.nodeMap)
    },
    getField ({objectApiName, fieldApiName}) {
      const fieldMap = this.store?.fieldMap && this.store.fieldMap() || {}
      return fieldMap?.[objectApiName]?.[fieldApiName]
    },
    // 获取路径 工场函数
    getPath ({rowId, fieldApiName, subObjectParamName, fieldType}) {
      /**
       * 主字段
       * 主查找关联内字段
       * 从某一行字段
       * 从全部列字段
       * 从某一行查找关联内字段
       * 从全部列查找关联内字段
       */
      let prop = []
      // 主对象字段
      if (!rowId) {
        prop.push(fieldApiName)
      }
      // 从对象字段
      if (rowId) {
        // 引用类型字段触发 非新建的行字段默认值无需生效
        if (fieldType !== FIELD_TYPE.QUOTE && !rowId.includes('_CREATE_')) {
          return ''
        }
        prop.push(...[
          subObjectParamName,
          this.subData.findIndex(v => v?.['aPaaS_SequenceId'] === rowId),
          fieldApiName
        ])
      }
      return prop.join('.')
    },
    // 赋值前的 最后处理
    _valueHandle (value, node = {}, parentNode = {}) {
      const {field} = node
      const _handle = beforeAssignmentHandle?.[field?.type] || beforeAssignmentHandle?.['default']
      let _value = value
      if (field && _handle) {
        _value = _handle({value, node, parentNode})
      }
      return _value
    },
    _setValue ({node, parentNode, value}) {
      const _path = this.getPath(node)
      let _value = this._valueHandle(value, node, parentNode)
      // 更新节点的值
      processRelate.updateNode(node, {value: _value})
      // 更新节点和formData的值
      _.set(this.formData, _path, _value)
    },
    // 处理触发事件
    async _handlerTrigger (node, parentNode = {}) {
      const {value, fieldClassification, fieldType, field} = parentNode
      const {relationFieldApiName} = node
      let parentValue = value

      // 查找关联需要取关联的字段值
      if (fieldType === FIELD_TYPE.LOOKUP_RELATION && relationFieldApiName) {
        if (parentValue && !_.get(parentValue, relationFieldApiName)) {
          parentValue = await this.getRowValue(field, parentValue)
        }
        parentValue = parentValue && _.get(parentValue, relationFieldApiName)
        // 无效值判断
        if (_.isUndefined(parentValue)) {
          parentValue = ''
        }
      }

      // 当前字段的默认值为全局变量
      if (fieldClassification === FIELD_VALUE_TYPE.GLOBAL) {
        let _value = this._handleGlobalField(parentNode)
        this._setValue({node, parentNode, value: _value})
        return
      }

      this._setValue({node, parentNode, value: parentValue})
    },
    // 处理全局变量字段
    _handleGlobalField ({fieldApiName, fieldExpress}) {
      return ({
        global__constant: fieldExpress,
        global__currentUser: getUserInfo(),
        global__currentUserDepart: getOrganization(),
        global__currentDate: moment(new Date()).format('YYYY-MM-DD'),
        global__currentTime: moment().format("YYYY-MM-DD HH:mm:ss")
      })?.[fieldApiName]
    },
    // 查询值能力接口
    async getRowValue (field, row) {
      const uniqueKey = field?.props?.interfacesGetValue?.requestParams?.uniqueKey
      const rowId = row?.[uniqueKey] || row
      // row 可能是 数字 字符串 空对象 对象
      if ((!_.isNumber(rowId) && _.isEmpty(rowId)) || !rowId || !uniqueKey) {
        return {}
      }
      if (catchRows[rowId]) {
        return catchRows[rowId]
      }
      const {relateObjectApiName, layoutApiName} = field.props?.params || {}
      const headerParams = {
        [HEADER_PARAMS_KEYS.tenantType]: field?.tenantType,
        [HEADER_PARAMS_KEYS.layoutApiName]: layoutApiName,
        [HEADER_PARAMS_KEYS.objectApiName]: relateObjectApiName
      }
      const {interfaces: {url, type}} = interfacesHandle(field.props.interfacesGetValue, row)
      const {content, isOk} = await cachedRequest(
        {type, url},
        {
          [uniqueKey]: rowId
        },
        false,
        {
          authError: false
        },
        headerParams
      )

      if (isOk) {
        catchRows[rowId] = content
        return content
      }
    }
  }
}
